export const environment = {
  production: true,
  froalaKey: "re1H1qB2C1E7E7B4E5G4iAa1Tb1YZNYAh1CUKUEQOHFVANUqD1G1F4B3B1C8A4D2G5A4==",
  apiBaseUrl: 'https://ipj-api.harappa.education/api/v1/',
  // apiBaseUrl: 'https://ipj-lrn-dev-api.harappa.education/api/v1/',
  // apiBaseUrl: 'http://172.16.12.140:8082/api/v1/',
  partnerApiBaseUrl: 'https://prod-authoring-partner-api.harappa.education/partner/v2/',
  basePath : 'https://ipj-api.harappa.education',
  businessDomain: 'https://business.harappa.education',
  mainDomain: 'https://app.harappa.education',
  webUrl: 'https://ipj.harappa.education',
  GOOGLE_RECAPTCHA_SITEKEY:'6LeW0qQrAAAAAEaMy-HaGCp-E65Kz-WpTnHLTgEw'
};
